export const tryToGetPermission = async () => {
  try {
    if (navigator.permissions) {
      const name = "microphone" as unknown as PermissionName;
      const res = await navigator.permissions.query({ name });
      if (res.state === "granted") {
        return true;
      }
      if (res.state === "denied") {
        return false;
      }
    }
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });
    // 没有流或者流是不活跃的，则表示可能无权限
    if (!mediaStream || !mediaStream.active) {
      return false;
    }
    const tracks = mediaStream.getTracks();
    tracks.forEach((track) => {
      track.stop();
    });
    return true;
  } catch (error) {
    console.log("tryToGetPermission", error);
    return false;
  }
};
